import { jsPDF } from "jspdf";
import Headerimg from "../../../../utils/header.jpeg";
import Footerimg from "../../../../utils/footer.jpeg";

export default function genPDF(props) {
  const { datos, cargo, edad, mescumple, preview, isShow } = props;
  const doc = new jsPDF();

  // Colores y tipografía
  const primary = [48, 74, 151];
  const secondary = [244, 132, 48];

  // Tamaños
  const titleSize = 16;  // títulos de sección
  const labelSize = 9;  // etiqueta
  const valueSize = 9;  // valor

  // Espaciado (compacto y consistente)
  const lineGap = 3;         // entre líneas del mismo campo
  const itemGap = 4;         // entre campos
  const blockGap = 13;       // entre bloques (general)
  const labelValueGap = 4;   // separación entre label y su valor
  const dpContactoGap = 5;   // GAP MÁS CORTO entre "Datos Personales" y "Contacto"

  const dividerColor = [228, 232, 236];

  // Página
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const headerBottomY = 35;
  const footerTop = 262;
  const safeTop = headerBottomY + 30; // por debajo de título "Ficha Profesional"
  const safeBottom = footerTop - 6;

  // Utilidades
  const safe = (v) => (v === null || v === undefined || v === "" ? "-" : String(v));

  const checkPageBreak = (nextY, extra = 0) => {
    if (nextY + extra > safeBottom) {
      doc.addPage();
      return safeTop;
    }
    return nextY;
  };

  const drawDivider = (x, y, w) => {
    doc.setDrawColor(...dividerColor);
    doc.setLineWidth(0.2);
    doc.line(x, y, x + w, y);
  };

  // Render de bloque (título centrado opcional, contenido alineado configurable)
  const renderBlock = ({
    title,
    items,
    x,
    y,
    width,
    titleAlign = "center",   // "left" | "center"
    contentAlign = "left",   // "left" | "center"
    dividers = true,
  }) => {
    let cy = y;

    // Título
    doc.setFontSize(titleSize);
    doc.setFont(undefined, "bold");
    doc.setTextColor(...primary);
    const titleX = titleAlign === "center" ? x + width / 2 : x;
    doc.text(title, titleX, cy, { align: titleAlign });
    cy += 8;

    // Contenido
    items.forEach((it, idx) => {
      const label = safe(it.label);
      const value = safe(it.value);

      // Label
      doc.setFontSize(labelSize);
      doc.setFont(undefined, "bold");
      doc.setTextColor(...primary);
      const contentX = contentAlign === "center" ? x + width / 2 : x;
      doc.text(label, contentX, cy, { align: contentAlign });

      // Value (más separado del label)
      cy += labelValueGap;
      doc.setFontSize(valueSize);
      doc.setFont(undefined, "normal");
      doc.setTextColor(60, 60, 60);

      const textWidth = contentAlign === "center" ? width - 8 : width;
      const lines = doc.splitTextToSize(value, textWidth);
      lines.forEach((ln) => {
        doc.text(ln, contentX, cy, { align: contentAlign });
        cy += lineGap;
      });

      // Separador
      if (dividers && idx < items.length - 1) {
        cy += 1;
        const dvX = x + (contentAlign === "center" ? 4 : 0);
        const dvW = contentAlign === "center" ? width - 8 : width;
        drawDivider(dvX, cy, dvW);
        cy += itemGap - 1;
      } else {
        cy += itemGap - 2;
      }

      cy = checkPageBreak(cy);
    });

    return cy;
  };

  // Header
  doc.addImage(Headerimg, "JPEG", 0, 0, pageWidth, headerBottomY);
  doc.setFontSize(18);
  doc.setTextColor(...primary);
  doc.setFont(undefined, "bold");
  doc.text("Ficha Profesional ", pageWidth / 2, headerBottomY + 10, { align: "center" });
  doc.setFontSize(10);
  doc.setTextColor(...secondary);
  if (isShow) {
    doc.text(isShow ? "Uso Interno" : "Uso Externo", pageWidth / 2, headerBottomY + 14, { align: "center" });
  }

  // BLOQUE SUPERIOR: Foto + Datos Personales centrados
  const photoW = 44;
  const photoH = 44;
  const gap = 14;
  const datosWidth = 120;

  const totalTopWidth = photoW + gap + datosWidth;
  const groupStartX = (pageWidth - totalTopWidth) / 2; // CENTRA el conjunto en la página

  const photoX = groupStartX;
  const datosX = photoX + photoW + gap;
  let cursorY = safeTop;

  // Foto
  if (preview) {
    doc.setDrawColor(210, 214, 219);
    doc.setLineWidth(0.3);
    doc.roundedRect(photoX - 1, cursorY - 1, photoW + 2, photoH + 2, 3, 3, "S");
    doc.addImage(preview, "JPEG", photoX, cursorY, photoW, photoH);
  }

  // Datos Personales (título centrado, contenido alineado a la izquierda para legibilidad)
  const datosItems = [
    { label: "Nombre Completo", value: datos?.Nombre },
    { label: "Cédula", value: datos?.Cedula },
    { label: "Sexo", value: datos?.sexo },
    { label: "Estado Civil", value: datos?.estadocivil },
    { label: "Hijos", value: datos?.hijos },
    { label: "Fecha de Nacimiento", value: datos?.Fechadenacimiento },
    { label: "Edad", value: edad },
    { label: "Mes de Cumpleaños", value: mescumple },
    { label: "Antecedente Policial", value: datos?.antpol },
  ];

  const afterDatosY = renderBlock({
    title: "Datos Personales",
    items: datosItems,
    x: datosX,
    y: cursorY,
    width: datosWidth,
    titleAlign: "center",
    contentAlign: "left",
    dividers: true,
  });

  // Cuenta debajo de la foto (igual que antes)
  const cuentaStartY = cursorY + photoH + blockGap;
  const cuentaWidth = Math.min(90, photoW + gap); // ancho razonable bajo foto
  const cuentaX = photoX + (photoW - cuentaWidth) / 2;

  renderBlock({
    title: "Cuenta",
    items: [
      { label: "Usuario", value: datos?.Usuario },
      { label: "Cargo", value: cargo },
      { label: "Profesión", value: datos?.subtipo },
      { label: "Registro Profesional", value: datos?.RegistroProfesional },
      ...(isShow ? [{ label: "Fecha de ingreso", value: datos?.Fechaingreso }] : []),
    ],
    x: cuentaX,
    y: checkPageBreak(cuentaStartY),
    width: cuentaWidth,
    titleAlign: "center",
    contentAlign: "center",
    dividers: true,
  });

  // Contacto DEBAJO de Datos Personales con MENOS separación (dpContactoGap)
  const contactoStartY = afterDatosY + dpContactoGap;

  renderBlock({
    title: "Contacto",
    items: [
      { label: "Departamento", value: datos?.departamento },
      { label: "Ciudad", value: datos?.Ciudad },
      { label: "Barrio", value: datos?.barrio },
      ...(isShow
        ? [
            { label: "Dirección", value: datos?.direccion },
            { label: "Número", value: datos?.Telefono },
          ]
        : []),
    ],
    x: datosX,
    y: checkPageBreak(contactoStartY-5),
    width: datosWidth,
    titleAlign: "center",
    contentAlign: "left",
    dividers: true,
  });

  // Footer
  doc.addImage(Footerimg, "JPEG", 0, footerTop, pageWidth, pageHeight - footerTop);

 
  // Guardar
  const tipouso = isShow ? "Uso Interno" : "Uso Externo";
  doc.save(`${safe(datos?.Nombre)}-${safe(datos?.Cedula)}-${tipouso}.pdf`);
}